<div class="modal-header">
    <h5 class="modal-title" id="profileModalTitle">Edit Membership Info</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageMembershipInfoForm">
        <div class="row gx-3">
            <!--<div class="col-md-6 mb-3">
            <label for="membershipLevel" class="form-label">Membership Level<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" id="membershipLevel" placeholder="Membership Level" formControlName="membershipLevel" autofocus>
            <div *ngIf="membershipLevelCtrl.invalid && (membershipLevelCtrl.dirty || membershipLevelCtrl.touched)">
                <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
        </div>-->
            <div class="col-md-6 mb-3">
                <label for="membershipLevel" class="form-label">Membership Level</label>
                <select formControlName="membershipLevel" class="form-select" aria-label="membershipLevel" id="membershipLevel">
                    <option *ngFor="let level of membershipLevelOptions" value="{{level.value}}">{{level.text}}</option>
                </select>
                <div *ngIf="membershipLevelCtrl.invalid && (membershipLevelCtrl.dirty || membershipLevelCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="total" class="form-label">Total<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="total" placeholder="0" formControlName="total" autofocus>
                <div *ngIf="totalCtrl.invalid && (totalCtrl.dirty || totalCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="form-check col-md-6" *ngIf="app.paymentAccountId != null">
                <label class="form-check-label" for="overridePayment">
                    Update Payment Method
                </label>
                <input formControlName="overridePayment" class="form-check-input" type="checkbox" id="overridePayment">
            </div>
            <div class="col-md-6">
                <div class="form-label">
                    <span>Curent Payment Method</span>
                </div>
                <div class="h6">
                    <span>{{app.maskedPaymentString}}</span>
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="app.paymentAccountId == null || overridePayment()">
            <div class="col-12 mb-3">
                <label for="paymentType" class="form-label d-block mb-2">Payment Type</label>
                <div class="btn-group paymentSelect mb-3" role="group" aria-label="Payment Type">
                    <input [value]="1" [formControl]="paymentTypeCtrl" [checked]="1" type="radio" class="btn-check" name="btnPaymentSelect" id="btnPaymentSelect1" autocomplete="off">
                    <label class="btn btn-outline-primary" for="btnPaymentSelect1">Credit Card</label>

                    <input [value]="2" [formControl]="paymentTypeCtrl" [checked]="2" type="radio" class="btn-check" name="btnPaymentSelect" id="btnPaymentSelect2" autocomplete="off">
                    <label class="btn btn-outline-primary" for="btnPaymentSelect2">eCheck</label>
                </div>
                <div *ngIf="paymentTypeCtrl.invalid && (paymentTypeCtrl.dirty || paymentTypeCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="app.paymentAccountId == null || overridePayment()">
            <div class="col-12 mb-3">
                <div class="paymentInputs">
                    <!-- show if credit card, otherwise class d-none hides -->
                    <div *ngIf="paymentType() == 1" class="row">
                        <div class="col-md-8 mb-3">
                            <label for="cardNo" class="form-label">Card Number</label>
                            <input formControlName="cardNumber" type="text" class="form-control" id="cardNo" placeholder="Card Number" minlength="13" maxlength="16">
                            <div *ngIf="cardNumberCtrl.invalid && (cardNumberCtrl.dirty || cardNumberCtrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md-2 mb-3">
                            <label for="cardExp" class="form-label">Expiration</label>
                            <input formControlName="cardExpiration" type="text" mask="00/00" class="form-control" id="cardExp" placeholder="MM/YY">
                            <div *ngIf="cardExpirationCtrl.invalid && (cardExpirationCtrl.dirty || cardExpirationCtrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md-2 mb-3">
                            <label for="cardCVV" class="form-label">CVV</label>
                            <input formControlName="cvv" type="text" class="form-control" id="cardCVV" placeholder="CVV" minlength="3" maxlength="4">
                            <div *ngIf="CVVCtrl.invalid && (CVVCtrl.dirty || CVVCtrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                    <!-- show if ach, otherwise class d-none hides -->
                    <div *ngIf="paymentType() == 2" class="row">
                        <div class="col-12 mb-3">
                            <label for="routingNo" class="form-label">Routing Number</label>
                            <input formControlName="routingNumber" type="text" class="form-control" id="routeNumber" placeholder="Routing Number" minlength="9" maxlength="9">
                            <div *ngIf="routingNumberCtrl.invalid && (routingNumberCtrl.dirty || routingNumberCtrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="accountNo" class="form-label">Account Number</label>
                            <input formControlName="accountNumber1" type="text" class="form-control" id="accNumber1" placeholder="Account Number" minlength="5" maxlength="17">
                            <div *ngIf="accountNumber1Ctrl.invalid && (accountNumber1Ctrl.dirty || accountNumber1Ctrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                            <div *ngIf="accountNumbersMatchError">
                                <i class="fas fa-exclamation-circle"></i> Account numbers do not match.
                            </div>

                        </div>
                        <div class="col-12 mb-3">
                            <label for="accountNo2" class="form-label">Confirm Account Number</label>
                            <input formControlName="accountNumber2" type="text" class="form-control" id="accNumber2" placeholder="Confirm Account Number" minlength="5" maxlength="17">
                            <div *ngIf="accountNumber2Ctrl.invalid && (accountNumber2Ctrl.dirty || accountNumber2Ctrl.touched)">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                            <div *ngIf="accountNumbersMatchError">
                                <i class="fas fa-exclamation-circle"></i> Account numbers do not match.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="row gx-3">
            <div class="col-12 mt-3">
                <label for="autoRenew" class="form-label">Auto-renew</label>
                <div class="form-check">
                    <input [value]="true" [formControl]="autoRenewCtrl" [checked]="true" class="form-check-input" type="radio" name="autoRenewRadio" id="autoRenewRadio1">
                    <label class="form-check-label" for="autoRenewRadio1">
                        Yes
                    </label>
                </div>
                <div class="form-check">
                    <input [value]="false" [formControl]="autoRenewCtrl" [checked]="false" class="form-check-input" type="radio" name="autoRenewRadio" id="autoRenewRadio2">
                    <label class="form-check-label" for="autoRenewRadio2">
                        No
                    </label>
                </div>
            </div>
        </div>-->
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="saveMembershipInfo()" [disabled]="isBusy" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
</div>
